var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2C2.44772 2 2 2.44772 2 3V5.25H7V3C7 2.44772 6.55228 2 6 2H3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.25V6.75H7V17.25H2ZM5.25 10C5.25 9.58579 4.91421 9.25 4.5 9.25C4.08579 9.25 3.75 9.58579 3.75 10V14C3.75 14.4142 4.08579 14.75 4.5 14.75C4.91421 14.75 5.25 14.4142 5.25 14V10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.75V21C2 21.5523 2.44772 22 3 22H6C6.55228 22 7 21.5523 7 21V18.75H2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C8.44771 2 8 2.44772 8 3V5.25H13V3C13 2.44772 12.5523 2 12 2H9Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.25V6.75H13V17.25H8ZM11.25 10C11.25 9.58579 10.9142 9.25 10.5 9.25C10.0858 9.25 9.75 9.58579 9.75 10V14C9.75 14.4142 10.0858 14.75 10.5 14.75C10.9142 14.75 11.25 14.4142 11.25 14V10Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.75V21C8 21.5523 8.44771 22 9 22H12C12.5523 22 13 21.5523 13 21V18.75H8Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7758 2.8042C13.2176 2.94598 12.8863 3.48987 13.0359 4.01901L13.6453 6.17477L18.6987 4.89118L18.0894 2.73541C17.9398 2.20628 17.3661 1.89226 16.8079 2.03404L13.7758 2.8042Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.895 17.6716L14.0515 7.6119L19.105 6.32831L21.9485 16.388L16.895 17.6716ZM18.2165 9.89149C18.1043 9.49464 17.674 9.25913 17.2554 9.36546C16.8367 9.4718 16.5883 9.87972 16.7005 10.2766L17.7837 14.1089C17.8959 14.5058 18.3262 14.7413 18.7449 14.6349C19.1635 14.5286 19.4119 14.1207 19.2998 13.7238L18.2165 9.89149Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3012 19.1087L17.9106 21.2646C18.0602 21.7937 18.6339 22.1077 19.1921 21.966L22.2242 21.1958C22.7824 21.054 23.1137 20.5101 22.9641 19.981L22.3547 17.8251L17.3012 19.1087Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.fbc96cccd48dc57439e164bf31a1f3db.svg";
export { ForwardRef as ReactComponent };